import { ApiProperty } from '@nestjs/swagger';
export class PlantRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    isPlantHO?: boolean;
}